import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Spinner, Alert } from "react-bootstrap";
// SAME FOLDER imports
import { useCTISSchema } from "./CTISSchemaProvider";
import CTISDynamicFormRenderer from "./CTISDynamicFormRenderer";

export default function CTISTemplateRendererPage() {
  const { templateId } = useParams();
  const { loadTemplate } = useCTISSchema();
  const [template, setTemplate] = useState(null);
  const [error, setError] = useState(null);
  const [localLoading, setLocalLoading] = useState(true);

  useEffect(() => {
    if (templateId && loadTemplate) {
      setLocalLoading(true);
      loadTemplate(templateId).then(data => {
        if (data) setTemplate(data);
        else setError(`Template '${templateId}' not found.`);
        setLocalLoading(false);
      });
    }
  }, [templateId, loadTemplate]);

  if (localLoading) return <div className="p-5 text-center"><Spinner animation="border" /></div>;
  if (error) return <Alert variant="danger" className="m-4">{error}</Alert>;

  return (
    <div className="p-4">
      <header className="mb-4 border-bottom pb-3">
        <h2 className="fw-bold text-dark">{template?.template_metadata?.official_sheet_name}</h2>
        <p className="text-secondary small mb-0">Fields: {template?.template_metadata?.field_count_flat}</p>
      </header>
      <CTISDynamicFormRenderer template={template} formData={{}} onFieldChange={() => {}} />
    </div>
  );
}